__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['banking-business-checking-root'].baseUrl;
import ModuleContainer from './components/BankingBusinessCheckingRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      'iguazu-rpc': '^1.6.1',
      'axp-product-ducks': '^0.4.20',
      '@americanexpress/one-experiments': '^2.1.3',
      '@tanstack/react-query': '^4.29.15'
    }
  });
}